export default {
  QQ_CLIENT_ID: "102049777",
  QQ_REDIRECT_URL: "https://jiangyinghui.cn/callback/qq",
  GITEE_CLIENT_ID: "545d8669b2d962af733c0202422216299a29026e342ae71e2ba16f9e598a995c",
  GITEE_REDIRECT_URL: "https://jiangyinghui.cn/callback/gitee",
  WEIBO_CLIENT_ID: "1627788593",
  WEIBO_REDIRECT_URL: "https://jiangyinghui.cn/callback/weibo",
};
